angular.module("componentes").controller("LoginOptionsCtrl", [
	"$scope",
	"$rootScope",
	"$state",
	"$stateParams",
	"accountService",
	"organizationService",
	"httpService",
	function ($scope, $rootScope, $state, $stateParams, accountService, organizationService, httpService) {
		"use strict";

		this.$onInit = function () {
			$scope.SSOEnabled = true;
			$scope.emailAndPasswordEnabled = true;
			if ($stateParams.error) {
				$rootScope.$broadcast(Vgr.constants.evtShowErrorMessage, $rootScope.labels.UNEXPECTED_LOGIN_ERROR);
			}

			if ($stateParams.appLogin) {
				accountService.setAppLogin(true);
			}
			const idp = getIdentityProvider();
			if ($stateParams.showOnlySSO == "true" && idp) {
				$scope.emailAndPasswordEnabled = false;
				$scope.toLoginWithSso();
				return;
			} else if (!idp) {
				$scope.SSOEnabled = false;
				return;
			}
			$scope.loading = true;
			httpService.getDTOFromServiceV2(organizationService.isOrganizationOnlySSO, idp, true).then(
				function (data) {
					$scope.emailAndPasswordEnabled = !data;
					$scope.loading = false;
				},
				function () {
					$scope.emailAndPasswordEnabled = true;
					$scope.loading = false;
				}
			);
		};

		$scope.labels = $rootScope.labels;
		$scope.step = 1;

		$scope.toLoginWithEmail = function () {
			$state.go("login", { showBack: true });
		};

		$scope.toLoginWithSso = function () {
			const idp = getIdentityProvider();
			if (!idp) {
				$state.go("login");
				return;
			}

			$scope.loading = true;
			accountService.validateIdentityProvider(idp).then(
				function (result) {
					if (result.data) {
						accountService.loginWithFederatedIdentity(idp);
					} else {
						$scope.loading = false;
						$scope.emailAndPasswordEnabled = true;
						$rootScope.$broadcast(Vgr.constants.evtShowErrorMessage, $scope.labels.INVALID_SSO_IDENTITY);
					}
				},
				function () {
					$scope.emailAndPasswordEnabled = true;
					$rootScope.$broadcast(Vgr.constants.evtShowErrorMessage, $rootScope.labels.UNEXPECTED_LOGIN_ERROR);
					$scope.loading = false;
				}
			);
		};

		$scope.backStep = function () {
			$scope.step = 1;
		};

		function getIdentityProvider() {
			return $stateParams.idp;
		}
	}
]);
